import * as React from "react";
import { Status } from "../Status";
import { RacingEventStatus } from "../../data/models/";

export const statusClasses = {
    isNotStarted: "",
    isRaceOff: "--raceoff",
    isResult: "--result",
    isOver: "--over"
}
export const statusText = {
    isNotStarted: "",
    isRaceOff: "O",
    isResult: "R",
    isOver: "X"
}

const defaultClass = "rj-racing-current-races__event";

/* istanbul ignore next */
const generateClasses = (status) => {
    return Object
        .keys(status)
        .filter(x => status[x] === true)
        .reduce((a, b) => a += ` ${defaultClass + statusClasses[b]}`, "");
};

/* istanbul ignore next */
const generateTxt = (status) => {
    return Object
        .keys(status)
        .filter(x => status[x] === true)
        .reduce((a, b) => a += ` ${statusText[b]} `, "");
};

export class Event extends React.Component<{ label?: string, url?: string, status?: RacingEventStatus, handler?: Function }, {}> {
    /* istanbul ignore next */
    void(): void { }

    /* istanbul ignore next */
    render() {
        let t = "" + (this.props.status ? generateTxt(this.props.status) : "");
        let h = this.props.handler || this.void;
        let cls = defaultClass + (this.props.status ? generateClasses(this.props.status) : "");
        return (
            <a
                href={this.props.url}
                className={cls}
                title={this.props.label}
                /* istanbul ignore next */
                onClick={/* istanbul ignore next */event => h(event)}>
                <Status text={t} />
                {this.props.label}
            </a>
        )
    }
}